export default "__VITE_ASSET__D5rCCI4h__"